import { consoleApi, createHttpClient } from "@nahal/api-client";
import { accessToken, useSession } from "./session";

const baseUrl = import.meta.env.VITE_PLATFORM_API_URL ?? "http://localhost:8083";

export const http = createHttpClient({
  baseUrl,
  getToken: accessToken,
  onUnauthorized: () => useSession.getState().clear(),
});

export const api = consoleApi(http);

/**
 * Exchanges the stored refresh token for a fresh access token on load. The
 * refresh token rotates on every use, so the new one is stored immediately --
 * dropping it would sign the user out on the next reload.
 */
export async function restoreSession() {
  const { refreshToken, setTokens, clear } = useSession.getState();
  if (!refreshToken) return false;
  try {
    const tokens = await api.refresh(refreshToken);
    setTokens(tokens.accessToken, tokens.refreshToken);
    return true;
  } catch {
    clear();
    return false;
  }
}
